export function isValueEnabled(value: any) {
  return ['1', 'true', 'yes', 'y', 'ja'].includes(
    String(value).trim().toLowerCase()
  )
}
